import React, { useEffect, useState } from "react";
import { AlertCircle, Check, Loader2, RotateCcw, X } from "lucide-react";
import { cn } from "@/lib/utils";

const elapsed = (iso) => Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));

/** Honest status for the background KI reading of the request text: running (with elapsed time + cancel), failed (retry), cancelled (retry). */
export function ReadingStatus({ reading, onRetry, onCancel, onDismiss }) {
  const [, tick] = useState(0);
  const running = reading?.status === "running";
  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(t);
  }, [running]);
  if (!reading || reading.status === "done") return null;
  const btn = "inline-flex h-6 items-center gap-1 rounded-full px-2 text-[11.5px] font-medium hover:bg-black/[0.06]";
  return (
    <div className={cn("mb-2 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-[14px] border px-3 py-2 text-[12px]", running ? "border-black/[0.08] bg-[hsl(210_20%_98.5%)]" : "border-[hsl(var(--v-blocked)/0.3)] bg-[hsl(var(--v-blocked)/0.05)]")} data-testid="reading-status" data-status={reading.status}>
      {running ? <Loader2 className="h-3.5 w-3.5 animate-spin text-primary" /> : reading.status === "cancelled" ? <X className="h-3.5 w-3.5 text-muted-foreground" /> : <AlertCircle className="h-3.5 w-3.5 text-[hsl(var(--v-blocked))]" />}
      <span className="min-w-0 flex-1">
        {running ? <>KI leser forespørselsteksten i bakgrunnen <span className="font-mono text-muted-foreground">({elapsed(reading.started_at)} s)</span> – du kan jobbe videre imens.</>
          : reading.status === "cancelled" ? "KI-lesingen ble avbrutt. Saksfakta er uendret."
            : <>KI-lesingen feilet{reading.error ? <span className="text-muted-foreground"> – {reading.error}</span> : null}. Dokumentene er lagret; bare den automatiske lesingen mangler.</>}
      </span>
      {running ? <button type="button" onClick={onCancel} className={cn(btn, "text-muted-foreground")} data-testid="reading-cancel"><X className="h-3 w-3" /> Avbryt</button> : (
        <>
          <button type="button" onClick={onRetry} className={cn(btn, "border border-black/[0.1] bg-white")} data-testid="reading-retry"><RotateCcw className="h-3 w-3" /> Prøv igjen</button>
          <button type="button" onClick={onDismiss} className={cn(btn, "text-muted-foreground")} aria-label="Skjul" data-testid="reading-dismiss"><Check className="h-3 w-3" /> OK</button>
        </>
      )}
    </div>
  );
}
